import { StartSignupForm } from "@/components/auth/start-signup-form.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { pageTitle } from "@/utils/page-title.ts";

// `ref` is the affiliate referral code from a partner's share link. Optional and
// only read here — it's forwarded to /api/auth/signup and bound to the email
// token, so it never needs to reach the post-verification /auth/signup page.
const startSignupSearchSchema = z.object({
	ref: z.string().optional(),
});

export const Route = createFileRoute("/auth/start-signup")({
	component: OrganizationRegisterComponent,
	validateSearch: startSignupSearchSchema,
	head: () => ({
		meta: [{ title: pageTitle(m.auth_start_signup()) }],
	}),
});

function OrganizationRegisterComponent() {
	const { ref } = Route.useSearch();
	return <StartSignupForm referralCode={ref} />;
}
